import removeFromCalendar from '../services/removeFromCalendar';
import MeetingCancellationMessageType from 'owa-service/lib/contract/MeetingCancellationMessageType';
import { action } from 'satcheljs/lib/legacy';
import { instantCalendarEventDelete } from 'owa-calendar-events-store';
import { ClientItemId } from 'owa-client-ids';
import { wrapInCalendarEventOperationResult } from './wrapInCalendarEventOperationResult';
import { getEventScope } from './getEventScope';
import { ViewType } from 'owa-calendar-actions';

export default action('removeCancelledMeetingFromCalendar')(
    function removeCancelledMeetingFromCalendar(
        item: MeetingCancellationMessageType,
        actionSource: ViewType
    ) {
        if (!item.AssociatedCalendarItemId) {
            removeFromCalendar(item);
            return;
        }

        instantCalendarEventDelete(
            item.AssociatedCalendarItemId as ClientItemId,
            getEventScope(item) /** eventScope */,
            null,
            () =>
                wrapInCalendarEventOperationResult(() =>
                    removeFromCalendar(item)
                ) /** actionToExecute */,
            () => {} /** onEventDeleteSuccess */,
            () => {} /** onEventDeleteFailed */,
            actionSource /** actionSource */
        );
    }
);
